module.exports = __webpack_public_path__ + "static/media/6.ff8e96eb.jpg";